// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/hooks/usePageData.tsx
// v1.0.0 - Hook lädt Seiten-Daten inkl. header_menu_id

import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface PageData {
  slug: string;
  name: string;
  path: string;
  header_menu_id: string | null;
  meta_title: string | null;
  meta_description: string | null;
  isLoading: boolean;
  isPublished: boolean;
  error: string | null;
}

export const usePageData = (): PageData => {
  const location = useLocation();
  const [data, setData] = useState<PageData>({
    slug: '',
    name: '',
    path: '',
    header_menu_id: null,
    meta_title: null,
    meta_description: null,
    isLoading: true,
    isPublished: true,
    error: null
  });

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const path = location.pathname === '/' ? '/' : location.pathname;
        const response = await fetch(`/system/api/v1/website/public/page?path=${encodeURIComponent(path)}`);
        
        if (response.status === 404) {
          setData(prev => ({
            ...prev,
            isPublished: false,
            isLoading: false,
            error: null
          }));
        } else if (response.ok) {
          const pageData = await response.json();
          setData({
            slug: pageData.slug,
            name: pageData.name,
            path: pageData.path,
            header_menu_id: pageData.header_menu_id,
            meta_title: pageData.meta_title,
            meta_description: pageData.meta_description,
            isLoading: false,
            isPublished: true,
            error: null
          });
        } else {
          setData(prev => ({
            ...prev,
            isPublished: true,
            isLoading: false,
            error: 'API Error'
          }));
        }
      } catch (err) {
        console.warn('Could not load page data:', err);
        setData(prev => ({
          ...prev,
          isPublished: true,
          isLoading: false,
          error: 'Network Error'
        }));
      }
    };

    fetchPageData();
  }, [location.pathname]);

  return data;
};

export default usePageData;
